export const UNPATHED_ERRORS_SYMBOL = Symbol('subschemaErrors');
export const OBJECT_SUBSCHEMA_SYMBOL = Symbol('initialSubschema');
export const FIELD_SUBSCHEMA_MAP_SYMBOL = Symbol('subschemaMap');
//# sourceMappingURL=symbols.js.map